module.exports = __webpack_public_path__ + "static/media/even-swiftness.bd24ef6b.png";